import { render } from "./Pagination.vue?vue&type=template&id=5404a016"
import script from "./Pagination.vue?vue&type=script&setup=true&lang=js"
export * from "./Pagination.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Reporting/Pagination.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5404a016"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5404a016', __exports__)) {
    api.reload('5404a016', __exports__)
  }
  
  module.hot.accept("./Pagination.vue?vue&type=template&id=5404a016", () => {
    api.rerender('5404a016', render)
  })

}


export default __exports__